import React from 'react';

const features = [
  'Automatizar processos burocráticos.',
  'Centralizar informações e dados.',
  'Gerar relatórios e análises em tempo real.',
  'Promover a participação cidadã e a transparência.',
  'Otimizar a alocação de recursos.',
];

const TransformacaoSection = () => (
  <section id="transformacao" className="py-24 bg-white overflow-hidden">
    <div className="container mx-auto px-6 md:px-12">
      <div className="flex flex-col lg:flex-row items-center gap-16">
        {/* Image */}
        <div className="lg:w-1/2 relative order-2 lg:order-1">
          <img
            src="https://i.ibb.co/DH4Wjybs/Whats-App-Image-2026-01-15-at-15-03-07.jpg"
            alt="Interface Nexus"
            className="rounded-lg shadow-lg w-full h-auto relative border border-gray-100"
            onError={e => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/600x440/EFF6FF/2563EB?text=Interface+Nexus';
            }}
          />
          {/* Floating badge */}
          <div className="absolute -bottom-4 -right-4 bg-white rounded-lg shadow-lg p-4 border border-gray-200">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: '#1B4F8A' }}>
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Eficiência</p>
                <p className="text-sm font-bold text-gray-900">+50% em 90 dias</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:w-1/2 order-1 lg:order-2 text-center lg:text-left">
          <div className="inline-flex items-center gap-2.5 mb-5 justify-center lg:justify-start">
            <span className="w-1 h-4 bg-blue-900" />
            <span className="text-xs font-bold uppercase tracking-widest text-blue-900">
              Plataforma Completa
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6 tracking-tight">
            A transformação na{' '}
            <span className="text-blue-900">Gestão Pública</span>{' '}
            começa aqui.
          </h2>
          <p className="text-gray-500 mb-8 leading-relaxed">
            Nossa plataforma oferece uma solução completa para modernizar a administração pública. Com ferramentas intuitivas e tecnologia de ponta, você pode:
          </p>
          <ul className="space-y-4 mb-10 text-left">
            {features.map((feat, i) => (
              <li key={i} className="flex items-center gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-blue-900 rounded-md flex items-center justify-center shadow-sm">
                  <svg className="w-3.5 h-3.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <span className="text-gray-700 font-medium text-sm">{feat}</span>
              </li>
            ))}
          </ul>
          <button
            onClick={() => document.querySelector('#planos')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 bg-blue-900 text-white font-bold px-8 py-3.5 rounded-lg shadow-sm hover:bg-blue-800 transition-all duration-200 text-sm"
          >
            Conheça os Planos
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </section>
);

export default TransformacaoSection;
